module.exports = __webpack_public_path__ + "img/goods-7.582038e1.png";